import React,{ useState, useEffect } from 'react';
import {DetailProspectionIntro} from "./DetailProspection/DetailProspectionIntro";
import {DetailProspectionTab} from "./DetailProspection/DetailProspectionTab";

export const DetailProspection = ({commune, openDownloadModal}) => {

    return (
        <>
            <section className="bg-gris pt-4">
                <div className="container py-4">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 px-4 px-md-2">
                            {commune && <DetailProspectionIntro commune={commune.nom} />}
                            {commune && <DetailProspectionTab commune={commune} openDownloadModal={openDownloadModal} />}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}